export default __webpack_public_path__ + "static/media/problem.e4e675d5.svg";